import React from 'react';
import PropTypes from 'prop-types';
import css from './Time.css';
import { dateRange } from '../../../utils/Recurrence';
import Title from 'common/Title';
import LinkButton from "../../../SF/LinkButton";
import { getDateFormat } from "../../../utils/time";

export default class Time extends React.Component {

  get recurrenceEndDate() {
    return this.props.recurrenceEndDate
      ? this.props.recurrenceEndDate.format(getDateFormat('weekdayDateDisplayFormat'))
      : "No later than end of term";
  }

  get periodInfo() {
    return this.props.recurring
      ? (
      <div className={"period-info"}>
        <div>Starts: {this.props.startDate.format(getDateFormat('weekdayDateDisplayFormat'))}</div>
        <div>Ends: {this.recurrenceEndDate}</div>
      </div>
      ) : null;
  }

  onClick(e) {
    if ( e ) e.preventDefault(); // Prevent errors on tests
    this.props.onChangeDurationClicked()
    return false;
  }

  get changeDurationLink() {
    return this.props.canChangeDuration
      ? <LinkButton className={'change-duration'}
                    onClick={this.onClick.bind(this)}>
        Change duration
      </LinkButton>
      : null;
  }

  render() {
    return (
      <div>
        <Title text="Date and Time" />
        <div className={css['text']}>
          <div className={css["time-info"]} data-role="reviewTimeInfo">{dateRange(this.props.duration, this.props.startDate, this.props.recurrenceLabel, this.props.recurring)}</div>
          {this.changeDurationLink}
          {this.periodInfo}
        </div>
      </div>
    );
  }
}

Time.propTypes = {
  startDate: PropTypes.object.isRequired,
  duration: PropTypes.number.isRequired,
  recurring: PropTypes.bool,
  recurrenceLabel: PropTypes.string,
  recurrenceEndDate: PropTypes.object,
  canChangeDuration: PropTypes.bool,
  onChangeDurationClicked: PropTypes.func
};
